import React, { useEffect } from 'react';
import styled from 'styled-components';
import FAQ from '../components/FAQ/FAQ';

const PageContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 150px; // Account for fixed header with larger logo

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding-top: 100px; /* Updated for new header height */
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding-top: 90px; /* Updated for new header height */
  }
`;

const FAQPage: React.FC = () => {
  useEffect(() => {
    document.title = 'FAQ - Radyofone | Frequently Asked Questions About Radio Streaming App';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Find answers to common questions about Radyofone radio streaming app. Learn about features, devices, offline listening, accounts, ads, premium plans, and how to get support.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', 'https://www.radyofone.com/faq');
  }, []);

  return (
    <PageContainer>
      <FAQ />
    </PageContainer>
  );
};

export default FAQPage;
